import { render, staticRenderFns } from "./Veranda.vue?vue&type=template&id=4595f2f8"
import script from "./Veranda.vue?vue&type=script&lang=ts"
export * from "./Veranda.vue?vue&type=script&lang=ts"
import style0 from "./Veranda.vue?vue&type=style&index=0&id=4595f2f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports